import styled from 'styled-components'

import { _3XS_Medium, mainColors, semanticColors } from '@avantstay/backoffice-core'

export const CaseCountContainer = styled.div<{ hasWarningCircle?: boolean }>`
  position: relative;
  ${_3XS_Medium};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: ${mainColors.neutralExtremelyDark};
  background-color: ${mainColors.neutralMedium};
  border-radius: 50%;

  ${({ hasWarningCircle }) =>
    hasWarningCircle &&
    `
    &::before {
      content: '';
      position: absolute;
      top: -2px;
      right: -2px;
      width: 6px;
      height: 6px;
      background-color: ${semanticColors.failureMedium};
      border-radius: 50%;
    }
  `}
`
